import { BaseMapper } from '@ps/utils';
import { ProjectManager } from '@ps/survey-utils';

import { ProjectManagerDto } from '../../dtos/project-manager.dto';

export class ProjectManagerMapper extends BaseMapper<
  ProjectManagerDto,
  ProjectManager
> {
  public fromDto(dto: ProjectManagerDto): ProjectManager {
    return {
      id: dto.id,
      name: dto.name,
      email: dto.email,
      company: dto.company,
    };
  }
}
